exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n[data-v-64dadb90] .el-input__inner, .el-date-editor.el-input[data-v-64dadb90]{\n  width: 1.6rem;\n}\n", ""]);

// exports
